// Browser-scoped persistence for `Game.seenHints`. The engine stays storage-agnostic;
// the UI seeds the set at construction (gameFactory / continue path) and writes it back
// on each per-turn save. localStorage may be unavailable or fail (private mode, quota);
// all access is wrapped to fail silently — hints will dedup within the session but won't
// persist across reloads in that case.

const STORAGE_KEY = "bullettime:seenHints";

export function loadSeenHints(): string[] {
	try {
		if (typeof localStorage === "undefined") return [];
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw === null) return [];
		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];
		return parsed.filter((id): id is string => typeof id === "string");
	} catch {
		return [];
	}
}

export function saveSeenHints(ids: Iterable<string>): void {
	try {
		if (typeof localStorage === "undefined") return;
		localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)));
	} catch {
		// ignore
	}
}

export function clearSeenHints(): void {
	try {
		if (typeof localStorage === "undefined") return;
		localStorage.removeItem(STORAGE_KEY);
	} catch {
		// ignore
	}
}
